import React, { useState } from 'react';
import classnames from 'classnames';

import { Modal, usePermissions } from 'components';

import { supplierTypes, userPermissions } from 'src/constants/enums';

import AddNewPrice from '../../../AddNewPrice';
import OfferWrapper from '../../../OfferWrapper';
import OtherSuppliers from '../../../OtherSuppliers';
import RefPrice from '../../../RefPrice';
import SelectedSupplierWrapper from '../../../SelectedSupplierWrapper';
import SuppliersList from '../../../SuppliersList';
import Details from '../../components/Details';
import ProductMenu from '../../components/ProductMenu';

import style from '../../Product.module.scss';

const ProductWithSelectedSuppliers = ({
  product,
  className,
  changeValuationSelections,
  showRefPrice = false,
  selectedCompany,
  type,
  recentlyOrdered
}) => {
  const { ref_price: refPrice } = product || {};
  const [isOpen, setIsOpen] = useState();

  const boxClasses = classnames(style.box, { [style.withRefPrice]: showRefPrice });
  const [canMenageCatalog] = usePermissions([userPermissions.offer_catalog.menage]);

  const primary = product.prices.find((sup) => sup.priority === supplierTypes.primary);
  const secondary = product.prices.find((sup) => sup.priority === supplierTypes.secondary);

  const primaryWithOptions = (product.prices.length > 0 && !secondary) || (product.prices.length > 1 && secondary);
  const secondaryWithOptions = (product.prices.length > 0 && !primary) || (product.prices.length > 1 && primary);

  return (
    <>
      <div className={boxClasses}>
        <Details
          className={className}
          product={product}
          showRefPrice={showRefPrice}
          orderedDate={recentlyOrdered}
        />
        <RefPrice
          price={refPrice}
          quantity={product.quantity}
          className={classnames(style.priceWrapper, style.ref)}
          showRefPrice={showRefPrice}
          selectedCompany={selectedCompany}
          productId={product.product_id}
        />
        <SelectedSupplierWrapper
          withOptions={canMenageCatalog ? primaryWithOptions : false}
          onClickEmpty={() => setIsOpen(true)}
        >
          {!!primary && (
            <div className={style.priceWrapper}>
              <OfferWrapper
                item={primary}
                product={product}
                changeValuationSelections={changeValuationSelections}
                selectedCompany={selectedCompany}
                type={type}
              />
            </div>
          )}
        </SelectedSupplierWrapper>
        <SelectedSupplierWrapper
          withOptions={canMenageCatalog ? secondaryWithOptions : false}
          onClickEmpty={() => setIsOpen(true)}
        >
          {!!secondary && (
            <div className={style.priceWrapper}>
              <OfferWrapper
                item={secondary}
                product={product}
                changeValuationSelections={changeValuationSelections}
                selectedCompany={selectedCompany}
              />
            </div>
          )}
        </SelectedSupplierWrapper>
        {canMenageCatalog && (
          <>
            <OtherSuppliers
              count={product.prices.length}
              onClick={() => setIsOpen(true)}
            />
            <AddNewPrice
              product={product}
              selectedCompany={selectedCompany}
            />
          </>
        )}
        <Modal
          visible={isOpen}
          onClose={() => setIsOpen(false)}
          title={'Wszystkie oferty'}
        >
          <SuppliersList
            product={product}
            changeValuationSelections={changeValuationSelections}
            selectedCompany={selectedCompany}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        </Modal>
        <ProductMenu
          selectedCompany={selectedCompany}
          product={product}
        />
      </div>
    </>
  );
};

export default ProductWithSelectedSuppliers;
